export default {
  wrapper: 'wrapper',
  listwrapper:
    'desktop-nav sm:w-10/12 mdp:w-12/12 bg-white sm:pl-0 sm:h-100-65vh lg:h-auto desktop-nav lg: lg:flex flex-wrap text-center items-center bg-white lg:justify-start justify-center sm:pl-0',
  navlist:
    ' relative lg:static menu-items text-center lg:text-left flex items-center sm:px-20 sm:pl-16 sm:pr-15 lg:px-0 lg:mx-20',
  navlistMobile: 'navlistMobile lg:hidden',
  navlistitem:
    'navlistitem font-BebasNeueRegular sm:w-full block text-black lg:border-none no-underline block sm:pl-0 sm:py-25 lg:py-0 text-18 lg:text-16 lg:tracking-0.48 menu-anchor outline-none sm:text-left lg:text-center  event_menu_click lg:font-BebasNeueBold',
  navlistitemCollection:
    'navlistitemCollection sm:w-full hidden lg:block text-black lg:border-none no-underline lg:px-0 pt-12 text-19 lg:text-16 lg:tracking-0.48 lg:mt-30 lg:mb-29 lg:p-0 lg:pt-0 font-BebasNeueRegular lg:font-BebasNeueBold menu-anchor outline-none',
  navlistitemMobile:
    'font-BebasNeueRegular sm:w-full block lg:hidden text-black lg:border-none no-underline block sm:pl-0 sm:py-25 lg:px-25 lg:py-0 text-18 lg:text-14 menu-anchor outline-none sm:text-left lg:text-center ',
  subMenuList: 'subMenuList leading-loose text-16 lg:pt-0 text-left',
  subMenuListText:
    'subMenuListText sm:py-20 sm:pl-0 lg:py-0 leading-22 lg:leading-30 lg:text-left sm:text-18 lg:text-14',
  hairAdvisorMenuText:
    'subMenuListText sm:pt-30 sm:pb-20 sm:pl-0 lg:py-0 leading-22 sm:leading-18 lg:leading-30 lg:text-left sm:text-14',
  subMenuLinks:
    'subMenuLinks sm:leading-22 sm:text-18 lg:text-14 lg:text-14 text-black no-underline lg:text-left font-HelveticaNeueLight lg:w-full',
  navlistitemselected: 'navlistitemselected',
  searchField: 'searchField ',
  searchButtonWrapper: 'searchButtonWrapper lg:mr-82 sm:mr-60',
  icon_search: 'icon_search',
  searchTxt: 'searchTxt hidden lg:block text-15 pl-10 font-HelveticaNeueRoman',
  icon_close: 'icon_close',
  searchFieldWrapper: 'searchFieldWrapper',
  socialIconsWrapper: 'socialIconsWrapper',
  socialIconsListWrapper: 'socialIconsListWrapper',
  iconlist: 'iconlist',
  menuImageWrapper: 'menu-image-wrapper w-6/12 lg:w-40p mr-20',
  menuImageWrapperContainer: 'flex flex-row',
  menuImage: 'menuImage',
  menuSlotImage: 'menuSlotImage',
  menuSlotButton:
    'menuSlotButton font-BebasNeueRegular sm:px-32 lg:px-42 sm:py-14 lg:py-14 inline-block float-left text-black no-underline border-1/2 border-solid border-black',
  menuWrapper: 'menuWrapper hidden',
  mobileMenuWrapper:
    'mobileMenuWrapper sm:flex sm:justify-end sm:flex-row-reverse lg:block sm:w-12/12 bg-white sm:mt-65 lg:mt-0 lg:pt-0',
  menuWrapperMobile: 'menuWrapperMobile lg:hidden',
  menuDropdownContainer:
    'w-full p-15 lg:pt-30 lg:pb-50 dropdown-menu-dt sm:h-100-65vh lg:h-auto mt-0 mb:0 lg:mb-20 w-11/12 bg-white menu-dt sm:-mt-50 lg:mt-0 overflow-auto lg:whitespace-nowrap',
  activeMenuWrapper:
    'activeMenuWrapper bg-white lg:bg-transparent lg:mt-80 lg:absolute z-10 w-full bg-white lg:flex lg:flex-wrap nav-dropdown-dt transition-all block z-11',
  downArrow: 'hidden lg:block downarrow',
  upArrow: 'lg:uparrow',
  leftArrow: 'leftArrow header-dropdown-left-arrow moblie-back-button lg:hidden',
  rightArrow: 'rightArrow',
  closeButton:
    'closeButton lg:block relative right-0 header-dropdown-close',
  menuSlotHeader:
    'text-18 lg:text-16 font-BebasNeueRegular py-25 text-left text-black child-anchor',
  menuSlotNonBold:
    'text-18 lg:text-16 py-10 text-center lg:text-left font-BebasNeueRegular lg:pt-0',
  menuSlotLink:
    'text-black no-underline cursor-default font-bold lg:tracking-0.48',
  menuSlotMobileLink:
    'menuSlotMobileLink text-grey-darkest text-18 no-underline font-HelveticaNeueLight sm:w-12/12 sm:text-left',
  menuSlotWrapper: 'menuSlotWrapper hidden lg:block w-4/12 lg:w-full relative',
  menuSlotWrapperMobile: 'menuSlotWrapperMobile lg:hidden w-full',
  subMenuWrapper: 'sub-menu-wraper',
  menuHeaderDesktop: 'menuHeaderDesktop',
  ulMenuList: 'sm:pt-35 ulMenuList sm:pl-0 lg:pt-0',
  subMenuOpen:
    'subMenuOpen absolute sm:w-100-60 lg:w-10/12 bg-white overflow-y-auto items-center justify-center h-100-65vh block z-1 pin-l-60',
  subMenuClose: 'subMenuClose hidden',
  hairAdvisorMenu: 'hairAdvisorMenu text-black text-16 leading-16 mb-8 block',
  menuHeaderButton:
    ' menuHeaderButton text-black font-HelveticaNeueMedium no-underline',
  menuHeaderWrapper:
    'text-20 menuHeaderWrapper hidden text-center lg:block p-20',
  closeButtonMobile: 'country-close block sm:hidden',
  menuItemHeader:
    'font-BebasNeueRegular menuItemHeader lg:hidden fixed sm:w-75-77 lg:w-12/12 sm:text-18 sm:leading-21 sm:tracking-wider z-0 bg-white top-0 sm:py-25 lg:py-0 text-left',
  mobileIcon: 'lg:hidden',
  iconButton: 'iconButton outline-n',
  iconImg: 'lg:hidden sm:m-17',
  leftMenuWrapper:
    'leftMenuWrapper pl-0 sm:w-65 lg:hidden sliding-tabs sm:h-100-65vh lg:h-auto',
  columnOne: 'columnOne w-full',
  columnTwo: 'columnTwo w-full',
  columnThree: 'columnThree w-full',
  showOnlyInMobile: 'showOnlyInMobile',
  showOnlyInDesktop: 'showOnlyInDesktop',
  loginButton:
    'text-16 text-black no-underline font-BebasNeueRegular  py-12 inline-block border-solid border-1  px-10  text-center w-55p  ',
  registerButton:
    'countryButtonText registerButtonText text-16 font-BebasNeueRegular ml-15  p-10 whitespace-nowrap w-55p',
  loginContainer:
    'lg:hidden sm:flex sm:self-end sm:justify-center sm:absolute sm:w-full sm:pb-100 px-30 bg-white z-10 pt-30',
  loginName:
    'loginName md:hidden font-BebasNeueBold absolute w-full flex justicy-start pl-78 top-24 text-black text-18 border-b-1 md:border-t-0 border-greyLine border-solid pb-20 md:pb-0',
};
